import './AiBusyComponent.scss';
import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../stores";
import {Button, Grid, Typography} from "@mui/material";
import {AdminPanelSettings, ChevronLeft} from "@mui/icons-material";
import {getStatusIsFinal} from "../../../../services/classes/JobClasses";
import {
    DevopsCategorizationStateDiagram
} from "../devops-categorization-state-diagram/DevopsCategorizationStateDiagram";
import {useLocation, useNavigate, useParams} from "react-router";
import {generateHomePath} from "../../../../routing/routing.utils";
import {RocketImage} from "../../../../components/icons/images/RocketImage";

export const AiBusyComponent: React.FC = observer(() => {
    const {rootAppStore, bagStore, categorizationReviewStore, authStore} = useStores();
    const statusDelegate = categorizationReviewStore.statusDelegate;
    const bagId = bagStore.bagId;

    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        statusDelegate.startCheckingStatus();
    }, [categorizationReviewStore]);
    const job = statusDelegate.latestCategorizationJob;
    const statusIsFinal = job && getStatusIsFinal(job.current_status.status);
    useEffect(() => {
        if (statusIsFinal) {
            statusDelegate.stopCheckingStatus();
        }
    }, [categorizationReviewStore, statusIsFinal]);

    return (
        <div className="ai-busy-component">
            <Grid container alignItems="center" direction="column">
                <Grid component="section">
                    <Typography variant="h4" className="text-center header">
                        Categorizing
                    </Typography>
                    <Typography variant="body2" className="text-center">
                        Your AI model is running, please come back later &hellip;
                    </Typography>
                </Grid>
                <Grid component="section">
                    {authStore.isMithraStaffGroup
                        ? <>
                            <a href={job?.gcp_cloudrun_link ? job.gcp_cloudrun_link : undefined} target="_blank"
                               rel="noreferrer">
                                <Button variant="outlined" startIcon={<AdminPanelSettings/>}>
                                    Open Run Jobs
                                </Button>
                            </a><br/>

                            <Button variant="outlined" startIcon={<AdminPanelSettings/>} onClick={() => {
                                statusDelegate.stopCheckingStatus();
                                categorizationReviewStore.reviewPageController.reviewPageStateController.setPage('review');
                            }}>
                                Go to review page
                            </Button><br/>

                            <DevopsCategorizationStateDiagram/>
                        </>
                        : <RocketImage/>
                    }
                </Grid>
                <Grid className="action-btn-container" component="section">
                    <Button
                        id="continue-categorization-btn"
                        color="primary"
                        variant="outlined"
                        startIcon={<ChevronLeft/>}
                        onClick={() => navigate(generateHomePath(location, {id: String(bagId)}, rootAppStore.app))}
                    >
                        Back
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
});
